import { ADMIN_API } from "./adminApi";
import { Paginated } from "./adminCommon.types";

export type AdminLogEntry = {
  id: number;
  action: string;
  entityType: string | null;
  entityId: string | null;
  metadata: Record<string, any> | null;
  createdAt: string;
  adminUser?: { id: number; name: string; email: string } | null;
  cliente?: { id: number; razaoSocial: string } | null;
};

export const listAdminLogs = async (params: Record<string, any> = {}) => {
  const { data } = await ADMIN_API.get<Paginated<AdminLogEntry>>("/api/admin/logs", { params });
  return data;
};
